// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2DQUF","header":"ReportDetails_header__31oF6","title":"ReportDetails_title__fp8I6","left":"ReportDetails_left__1Wegi"};